export const fonts: FontProps[] = [
  {
    fontFamily: "Sora",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-Bold.ttf",
      format: "ttf",
    },
    fontWeight: 700,
    fontDisplay: "swap",
  },
  {
    fontFamily: "Sora",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-Bold.woff2",
      format: "woff2",
    },
    fontWeight: 700,
    fontDisplay: "swap",
  },
  {
    fontFamily: "Sora",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-SemiBold.ttf",
      format: "ttf",
    },
    fontWeight: 600,
    fontDisplay: "swap",
  },
  {
    fontFamily: "Sora",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-SemiBold.woff2",
      format: "woff2",
    },
    fontWeight: 600,
    fontDisplay: "swap",
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-SemiBold.ttf",
      format: "ttf",
    },
    fontWeight: 600,
    fontDisplay: "swap",
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Semibold.ttf.woff2",
      format: "woff2",
    },
    fontWeight: 600,
    fontDisplay: "swap",
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Regular.ttf",
      format: "ttf",
    },
    fontWeight: 400,
    fontDisplay: "swap",
  },
  {
    fontFamily: "Source Sans 3",
    webFont: {
      url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Regular.ttf.woff2",
      format: "woff2",
    },
    fontWeight: 400,
    fontDisplay: "swap",
  },
];

export type FontFormat =
  | "woff"
  | "woff2"
  | "truetype"
  | "opentype"
  | "embedded-opentype"
  | "svg"
  | "ttf";

export type FontWeight = 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
export type FontDisplay = "auto" | "block" | "swap" | "fallback" | "optional";
export type FontStyle = "normal" | "italic" | "oblique" | "inherit" | "initial";

export type FontProps = {
  fontFamily: string;
  webFont?: {
    url: string;
    format: FontFormat;
  };
  fontWeight?: FontWeight;
  fontStyle?: FontStyle;
  fontDisplay?: FontDisplay;
};
